module.exports = __webpack_public_path__ + "static/react-4ade5cac5aba1b2a6129e12ce9a93deb.png";